import { jsx as y, jsxs as Ve } from "react/jsx-runtime";
import * as s from "react";
import { forwardRef as Ke } from "react";
import { S as qe, u as R, a as Ze } from "./index-B_6_jmOO.js";
import * as Je from "react-dom";
import { u as Qe, o as et, s as tt, f as nt, a as rt, b as ot, h as st, l as it, c as at } from "./floating-ui.react-dom-JfyihLpw.js";
import { $ as ct } from "./utils-CTvPli9r.js";
function A(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function ue(e, t = []) {
  let n = [];
  function r(i, a) {
    const d = s.createContext(a), l = n.length;
    n = [...n, a];
    const c = (f) => {
      var x;
      const { scope: h, children: p, ...v } = f, m = ((x = h == null ? void 0 : h[e]) == null ? void 0 : x[l]) || d, g = s.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ y(m.Provider, { value: g, children: p });
    };
    c.displayName = i + "Provider";
    function u(f, h) {
      var m;
      const p = ((m = h == null ? void 0 : h[e]) == null ? void 0 : m[l]) || d, v = s.useContext(p);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const o = () => {
    const i = n.map((a) => s.createContext(a));
    return function(d) {
      const l = (d == null ? void 0 : d[e]) || i;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...d, [e]: l } }),
        [d, l]
      );
    };
  };
  return o.scopeName = e, [r, lt(o, ...t)];
}
function lt(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = r.reduce((d, { useScope: l, scopeName: c }) => {
        const f = l(i)[`__scope${c}`];
        return { ...d, ...f };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var ut = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], N = ut.reduce((e, t) => {
  const n = s.forwardRef((r, o) => {
    const { asChild: i, ...a } = r, d = i ? qe : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ y(d, { ...a, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function dt(e, t) {
  e && Je.flushSync(() => e.dispatchEvent(t));
}
function L(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function ft(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = L(e);
  s.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var pt = "DismissableLayer", G = "dismissableLayer.update", ht = "dismissableLayer.pointerDownOutside", vt = "dismissableLayer.focusOutside", ce, de = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), fe = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: d,
      ...l
    } = e, c = s.useContext(de), [u, f] = s.useState(null), h = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = s.useState({}), v = R(t, (w) => f(w)), m = Array.from(c.layers), [g] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), x = m.indexOf(g), C = u ? m.indexOf(u) : -1, E = c.layersWithOutsidePointerEventsDisabled.size > 0, P = C >= x, T = gt((w) => {
      const O = w.target, k = [...c.branches].some((M) => M.contains(O));
      !P || k || (o == null || o(w), a == null || a(w), w.defaultPrevented || d == null || d());
    }, h), b = wt((w) => {
      const O = w.target;
      [...c.branches].some((M) => M.contains(O)) || (i == null || i(w), a == null || a(w), w.defaultPrevented || d == null || d());
    }, h);
    return ft((w) => {
      C === c.layers.size - 1 && (r == null || r(w), !w.defaultPrevented && d && (w.preventDefault(), d()));
    }, h), s.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (ce = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), le(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = ce);
        };
    }, [u, h, n, c]), s.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), le());
    }, [u, c]), s.useEffect(() => {
      const w = () => p({});
      return document.addEventListener(G, w), () => document.removeEventListener(G, w);
    }, []), /* @__PURE__ */ y(
      N.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: E ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: A(e.onFocusCapture, b.onFocusCapture),
        onBlurCapture: A(e.onBlurCapture, b.onBlurCapture),
        onPointerDownCapture: A(
          e.onPointerDownCapture,
          T.onPointerDownCapture
        )
      }
    );
  }
);
fe.displayName = pt;
var mt = "DismissableLayerBranch", yt = s.forwardRef((e, t) => {
  const n = s.useContext(de), r = s.useRef(null), o = R(t, r);
  return s.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ y(N.div, { ...e, ref: o });
});
yt.displayName = mt;
function gt(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = L(e), r = s.useRef(!1), o = s.useRef(() => {
  });
  return s.useEffect(() => {
    const i = (d) => {
      if (d.target && !r.current) {
        let l = function() {
          pe(
            ht,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: d };
        d.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function wt(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = L(e), r = s.useRef(!1);
  return s.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && pe(vt, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function le() {
  const e = new CustomEvent(G);
  document.dispatchEvent(e);
}
function pe(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? dt(o, i) : o.dispatchEvent(i);
}
var D = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, xt = s.useId || (() => {
}), Ct = 0;
function Pt(e) {
  const [t, n] = s.useState(xt());
  return D(() => {
    n((r) => r ?? String(Ct++));
  }, [e]), t ? `radix-${t}` : "";
}
var bt = "Arrow", he = s.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ y(
    N.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ y("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
he.displayName = bt;
var Et = he;
function Tt(e) {
  const [t, n] = s.useState(void 0);
  return D(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, d;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, d = c.blockSize;
        } else
          a = e.offsetWidth, d = e.offsetHeight;
        n({ width: a, height: d });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var K = "Popper", [ve, me] = ue(K), [At, ye] = ve(K), ge = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = s.useState(null);
  return /* @__PURE__ */ y(At, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
ge.displayName = K;
var we = "PopperAnchor", xe = s.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = ye(we, n), a = s.useRef(null), d = R(t, a);
    return s.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ y(N.div, { ...o, ref: d });
  }
);
xe.displayName = we;
var q = "PopperContent", [Ot, Rt] = ve(q), Ce = s.forwardRef(
  (e, t) => {
    var te, ne, re, oe, se, ie;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: d = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: v,
      ...m
    } = e, g = ye(q, n), [x, C] = s.useState(null), E = R(t, (I) => C(I)), [P, T] = s.useState(null), b = Tt(P), w = (b == null ? void 0 : b.width) ?? 0, O = (b == null ? void 0 : b.height) ?? 0, k = r + (i !== "center" ? "-" + i : ""), M = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, J = Array.isArray(c) ? c : [c], Ie = J.length > 0, $ = {
      padding: M,
      boundary: J.filter(St),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: Ie
    }, { refs: ke, floatingStyles: Q, placement: $e, isPositioned: W, middlewareData: S } = Qe({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: k,
      whileElementsMounted: (...I) => at(...I, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        et({ mainAxis: o + O, alignmentAxis: a }),
        l && tt({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? it() : void 0,
          ...$
        }),
        l && nt({ ...$ }),
        rt({
          ...$,
          apply: ({ elements: I, rects: ae, availableWidth: Ye, availableHeight: je }) => {
            const { width: Ge, height: Xe } = ae.reference, B = I.floating.style;
            B.setProperty("--radix-popper-available-width", `${Ye}px`), B.setProperty("--radix-popper-available-height", `${je}px`), B.setProperty("--radix-popper-anchor-width", `${Ge}px`), B.setProperty("--radix-popper-anchor-height", `${Xe}px`);
          }
        }),
        P && ot({ element: P, padding: d }),
        Dt({ arrowWidth: w, arrowHeight: O }),
        h && st({ strategy: "referenceHidden", ...$ })
      ]
    }), [ee, We] = Ee($e), H = L(v);
    D(() => {
      W && (H == null || H());
    }, [W, H]);
    const He = (te = S.arrow) == null ? void 0 : te.x, Be = (ne = S.arrow) == null ? void 0 : ne.y, Fe = ((re = S.arrow) == null ? void 0 : re.centerOffset) !== 0, [Ue, ze] = s.useState();
    return D(() => {
      x && ze(window.getComputedStyle(x).zIndex);
    }, [x]), /* @__PURE__ */ y(
      "div",
      {
        ref: ke.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Q,
          transform: W ? Q.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Ue,
          "--radix-popper-transform-origin": [
            (oe = S.transformOrigin) == null ? void 0 : oe.x,
            (se = S.transformOrigin) == null ? void 0 : se.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ie = S.hide) == null ? void 0 : ie.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ y(
          Ot,
          {
            scope: n,
            placedSide: ee,
            onArrowChange: T,
            arrowX: He,
            arrowY: Be,
            shouldHideArrow: Fe,
            children: /* @__PURE__ */ y(
              N.div,
              {
                "data-side": ee,
                "data-align": We,
                ...m,
                ref: E,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: W ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Ce.displayName = q;
var Pe = "PopperArrow", Nt = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, be = s.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = Rt(Pe, r), a = Nt[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ y(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ y(
          Et,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
be.displayName = Pe;
function St(e) {
  return e !== null;
}
var Dt = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, x, C;
    const { placement: n, rects: r, middlewareData: o } = t, a = ((g = o.arrow) == null ? void 0 : g.centerOffset) !== 0, d = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [c, u] = Ee(n), f = { start: "0%", center: "50%", end: "100%" }[u], h = (((x = o.arrow) == null ? void 0 : x.x) ?? 0) + d / 2, p = (((C = o.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
    let v = "", m = "";
    return c === "bottom" ? (v = a ? f : `${h}px`, m = `${-l}px`) : c === "top" ? (v = a ? f : `${h}px`, m = `${r.floating.height + l}px`) : c === "right" ? (v = `${-l}px`, m = a ? f : `${p}px`) : c === "left" && (v = `${r.floating.width + l}px`, m = a ? f : `${p}px`), { data: { x: v, y: m } };
  }
});
function Ee(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var _t = ge, Lt = xe, Mt = Ce, It = be;
function kt(e, t) {
  return s.useReducer((n, r) => t[n][r] ?? n, e);
}
var Te = (e) => {
  const { present: t, children: n } = e, r = $t(t), o = typeof n == "function" ? n({ present: r.isPresent }) : s.Children.only(n), i = R(r.ref, Wt(o));
  return typeof n == "function" || r.isPresent ? s.cloneElement(o, { ref: i }) : null;
};
Te.displayName = "Presence";
function $t(e) {
  const [t, n] = s.useState(), r = s.useRef({}), o = s.useRef(e), i = s.useRef("none"), a = e ? "mounted" : "unmounted", [d, l] = kt(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const c = F(r.current);
    i.current = d === "mounted" ? c : "none";
  }, [d]), D(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const h = i.current, p = F(c);
      e ? l("MOUNT") : p === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), D(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, f = (p) => {
        const m = F(r.current).includes(p.animationName);
        if (p.target === t && m && (l("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, h = (p) => {
        p.target === t && (i.current = F(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(d),
    ref: s.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function F(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Wt(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Ht({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = Bt({ defaultProp: t, onChange: n }), i = e !== void 0, a = i ? e : r, d = L(n), l = s.useCallback(
    (c) => {
      if (i) {
        const f = typeof c == "function" ? c(e) : c;
        f !== e && d(f);
      } else
        o(c);
    },
    [i, e, o, d]
  );
  return [a, l];
}
function Bt({
  defaultProp: e,
  onChange: t
}) {
  const n = s.useState(e), [r] = n, o = s.useRef(r), i = L(t);
  return s.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var Ft = "VisuallyHidden", Ae = s.forwardRef(
  (e, t) => /* @__PURE__ */ y(
    N.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Ae.displayName = Ft;
var Ut = Ae, [U, hn] = ue("Tooltip", [
  me
]), z = me(), Oe = "TooltipProvider", zt = 700, X = "tooltip.open", [Yt, Z] = U(Oe), Re = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = zt,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [a, d] = s.useState(!0), l = s.useRef(!1), c = s.useRef(0);
  return s.useEffect(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ y(
    Yt,
    {
      scope: t,
      isOpenDelayed: a,
      delayDuration: n,
      onOpen: s.useCallback(() => {
        window.clearTimeout(c.current), d(!1);
      }, []),
      onClose: s.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => d(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: l,
      onPointerInTransitChange: s.useCallback((u) => {
        l.current = u;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
Re.displayName = Oe;
var Y = "Tooltip", [jt, j] = U(Y), Ne = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: d
  } = e, l = Z(Y, e.__scopeTooltip), c = z(t), [u, f] = s.useState(null), h = Pt(), p = s.useRef(0), v = a ?? l.disableHoverableContent, m = d ?? l.delayDuration, g = s.useRef(!1), [x = !1, C] = Ht({
    prop: r,
    defaultProp: o,
    onChange: (w) => {
      w ? (l.onOpen(), document.dispatchEvent(new CustomEvent(X))) : l.onClose(), i == null || i(w);
    }
  }), E = s.useMemo(() => x ? g.current ? "delayed-open" : "instant-open" : "closed", [x]), P = s.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, g.current = !1, C(!0);
  }, [C]), T = s.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, C(!1);
  }, [C]), b = s.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      g.current = !0, C(!0), p.current = 0;
    }, m);
  }, [m, C]);
  return s.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ y(_t, { ...c, children: /* @__PURE__ */ y(
    jt,
    {
      scope: t,
      contentId: h,
      open: x,
      stateAttribute: E,
      trigger: u,
      onTriggerChange: f,
      onTriggerEnter: s.useCallback(() => {
        l.isOpenDelayed ? b() : P();
      }, [l.isOpenDelayed, b, P]),
      onTriggerLeave: s.useCallback(() => {
        v ? T() : (window.clearTimeout(p.current), p.current = 0);
      }, [T, v]),
      onOpen: P,
      onClose: T,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
Ne.displayName = Y;
var V = "TooltipTrigger", Se = s.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = j(V, n), i = Z(V, n), a = z(n), d = s.useRef(null), l = R(t, d, o.onTriggerChange), c = s.useRef(!1), u = s.useRef(!1), f = s.useCallback(() => c.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ y(Lt, { asChild: !0, ...a, children: /* @__PURE__ */ y(
      N.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: A(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: A(e.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: A(e.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: A(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: A(e.onBlur, o.onClose),
        onClick: A(e.onClick, o.onClose)
      }
    ) });
  }
);
Se.displayName = V;
var Gt = "TooltipPortal", [vn, Xt] = U(Gt, {
  forceMount: void 0
}), _ = "TooltipContent", De = s.forwardRef(
  (e, t) => {
    const n = Xt(_, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, a = j(_, e.__scopeTooltip);
    return /* @__PURE__ */ y(Te, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ y(_e, { side: o, ...i, ref: t }) : /* @__PURE__ */ y(Vt, { side: o, ...i, ref: t }) });
  }
), Vt = s.forwardRef((e, t) => {
  const n = j(_, e.__scopeTooltip), r = Z(_, e.__scopeTooltip), o = s.useRef(null), i = R(t, o), [a, d] = s.useState(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: f } = r, h = s.useCallback(() => {
    d(null), f(!1);
  }, [f]), p = s.useCallback(
    (v, m) => {
      const g = v.currentTarget, x = { x: v.clientX, y: v.clientY }, C = Jt(x, g.getBoundingClientRect()), E = Qt(x, C), P = en(m.getBoundingClientRect()), T = nn([...E, ...P]);
      d(T), f(!0);
    },
    [f]
  );
  return s.useEffect(() => () => h(), [h]), s.useEffect(() => {
    if (l && u) {
      const v = (g) => p(g, u), m = (g) => p(g, l);
      return l.addEventListener("pointerleave", v), u.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", v), u.removeEventListener("pointerleave", m);
      };
    }
  }, [l, u, p, h]), s.useEffect(() => {
    if (a) {
      const v = (m) => {
        const g = m.target, x = { x: m.clientX, y: m.clientY }, C = (l == null ? void 0 : l.contains(g)) || (u == null ? void 0 : u.contains(g)), E = !tn(x, a);
        C ? h() : E && (h(), c());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [l, u, a, c, h]), /* @__PURE__ */ y(_e, { ...e, ref: i });
}), [Kt, qt] = U(Y, { isInside: !1 }), _e = s.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...d
    } = e, l = j(_, n), c = z(n), { onClose: u } = l;
    return s.useEffect(() => (document.addEventListener(X, u), () => document.removeEventListener(X, u)), [u]), s.useEffect(() => {
      if (l.trigger) {
        const f = (h) => {
          const p = h.target;
          p != null && p.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ y(
      fe,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ Ve(
          Mt,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...d,
            ref: t,
            style: {
              ...d.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ y(Ze, { children: r }),
              /* @__PURE__ */ y(Kt, { scope: n, isInside: !0, children: /* @__PURE__ */ y(Ut, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
De.displayName = _;
var Le = "TooltipArrow", Zt = s.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = z(n);
    return qt(
      Le,
      n
    ).isInside ? null : /* @__PURE__ */ y(It, { ...o, ...r, ref: t });
  }
);
Zt.displayName = Le;
function Jt(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Qt(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function en(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function tn(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const d = t[i].x, l = t[i].y, c = t[a].x, u = t[a].y;
    l > r != u > r && n < (c - d) * (r - l) / (u - l) + d && (o = !o);
  }
  return o;
}
function nn(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), rn(t);
}
function rn(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var on = Re, sn = Ne, an = Se, Me = De;
const mn = on, yn = sn, gn = an, cn = Ke(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ y(
  Me,
  {
    ref: r,
    sideOffset: t,
    className: ct(
      "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
));
cn.displayName = Me.displayName;
export {
  yn as Tooltip,
  cn as TooltipContent,
  mn as TooltipProvider,
  gn as TooltipTrigger
};
//# sourceMappingURL=tooltip.js.map
